<template>
  <div>AuthorizeDropBox query: {{ $route.query }}</div>
</template>

<script>
import axios from "axios";
export default {
  name: "AuthorizeDropBox",
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this.$route.query);
    this.authorize();
  },
  beforeDestroy() {},
  methods: {
    authorize() {
      var data = {
        code: this.$route.query.code,
        state: this.$route.query.state,
      };
      axios
        .post(this.serverURL + "/dropbox_finalize_auth", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
